import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrderManagementApiService from './OrderManagementApiService';
import api from "../../client/utils/clientApiHelper";
import { UPDATE_COST_CENTER, VALIDATE_AND_SAVE_MULTIPLE_PO } from 'Store/OrderManagement/FleetProcessing/FleetProcessingType';
import { updateCostCenterResponse, setValidateAndSavePOSuccess } from 'Store/OrderManagement/FleetProcessing/FleetProcessingAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* updateCostCenter(costCenter: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint : `orders/costcenter`,
            apiMethod :  apiMethod.POST,
            payload : costCenter.costCenter
           
        }
        yield put(globalLoaderText("Updating Cost Center...."));  
        
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp,
            payloadData
        );
        yield put(globalLoaderText(""));
        yield put(updateCostCenterResponse(response));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(updateCostCenterResponse(false));
    }
}

function* validateAndSaveMultiplePo(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/items/validateandsave`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
           
        }
        yield put(globalLoaderText("Saving purchase order detail...."));  
        const response = yield call(
            api.callFleetPost, API_URL.PostWebApp, payloadData
        
        );
        yield put(globalLoaderText(""));
        yield put(setValidateAndSavePOSuccess(response));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setValidateAndSavePOSuccess(false));
    }
}

function* watchOrder() {
    yield takeEvery(UPDATE_COST_CENTER, updateCostCenter);
    yield takeEvery(VALIDATE_AND_SAVE_MULTIPLE_PO, validateAndSaveMultiplePo);
}

export default function* combinedSaga() {
    yield all([
        watchOrder()
    ])
}
